<template>
  <el-dialog
    :close-on-press-escape="false"
    title="作業回別コメント"
    top="5vh"
    :visible.sync="dialogVisible"
    append-to-body
    width="900px"
    @close="close"
  >
    <vab-form ref="form" :model="form" :rules="rules">
      <div class="sure_box top_info mtn">
        <vab-row class="row_box">
          <vab-col :span="24" class="title_box title_header">
            作業回別コメント
          </vab-col>
        </vab-row>
        <vab-row v-for="(itm, idx) in form.dataList" :key="idx" class="row_box">
          <vab-col :span="24" class="word_box nopadding2">
            <div class="flex_start flex_center_align">
              <p>&nbsp;{{ itm.id }}&nbsp;&nbsp;</p>
              <vab-input :prop="`dataList.${idx}.text`" class="percentInput" />
            </div>
          </vab-col>
        </vab-row>
      </div>
    </vab-form>
    <div slot="footer" class="dialog-footer flex_end mg12">
      <div class="flex_start flex_center_align">
        <div class="cancel" @click="close">キャンセル</div>
        <vab-button :btn-list="btnList" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'Work',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dialogVisible: false,
        form: {
          dataList: [],
        },
        rules: {},
        btnList: [
          {
            name: '更新',
            icon: 'answer',
            type: 'button',
            hidden: false,
            click: (row) => {
              console.log('???', row)
            },
          },
        ],
      }
    },
    watch: {
      visible: function (val) {
        this.dialogVisible = val
      },
    },
    methods: {
      close() {
        this.dialogVisible = false
        this.$emit('update:visibleWork', false)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .percentInput {
    width: 100%;
  }
  ::v-deep .el-dialog__body {
    padding: 30px 24px !important;
  }
</style>
